
const zIndex = {
    mobileStepper: 800,
    speedDial: 850,
    appBar: 900,
    drawer: 1000,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500,
};


export default (siteConf) => ({
    zIndex,
    overrides: {
        MuiInputBase: {
            input: {
                fontWeight: 400
            },
            root: {
                '&$focused': {
                    '& $input': {
                        boxShadow: 'none'
                    }
                },
            }
        },
        MuiToolbar: {
            regular: {
                ['@media (min-width:0px)']: {
                    minHeight: 60
                },
            }
        },
        MuiTab: {
            wrapper: {
                fontWeight: 600,
            }
        }
    },
    palette: {
        primary: {
            main: siteConf.color1,
            contrastText: 'white'
        },
        text: {
            primary: '#32333C',
        }
    },
    typography: {
        fontFamily: 'Titillium Web',
        h5: {
            fontSize: 16,
            fontWeight: 600,
            color: 'inherit'
        },
        subtitle1: {
            fontSize: 12,
            fontWeight: 600,

        },
        subtitle2: {
            fontSize: 12,
            color: 'inherit'
        },
        body1: {
            fontSize: 14,
            fontWeight: 600
        },
        body2: {
            fontSize: 14,
        },
    }
});
